import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "components/Layout";
import api from "utils/api";
import { setLogin } from "state";
import "styles/auth.css";

const LoginPage = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const next = params.get("next") || "/konto";

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const { data } = await api.post("/auth/login", form);
      dispatch(setLogin({ token: data.token, user: data.user }));
      navigate(next, { replace: true });
    } catch (err) {
      setError(err?.response?.data?.message || "Login fehlgeschlagen.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Layout>
      <section className="auth-page">
        <div className="auth-card">
          <div className="auth-kicker">Login</div>
          <h1>
            Willkommen <em>zurück</em>
          </h1>
          <p className="auth-lead">
            Melde dich an, um Studio- und Vor-Ort-Termine zu buchen oder deine
            bestehenden Buchungen zu verwalten.
          </p>

          {error && <div className="auth-alert is-error">{error}</div>}

          <form className="auth-form" onSubmit={handleSubmit} noValidate>
            <div>
              <label htmlFor="login-email">E-Mail</label>
              <input
                id="login-email"
                type="email"
                autoComplete="email"
                required
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div>
              <label htmlFor="login-password">Passwort</label>
              <input
                id="login-password"
                type="password"
                autoComplete="current-password"
                required
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>
            <div className="auth-actions">
              <button type="submit" className="auth-submit" disabled={submitting}>
                {submitting ? "Anmelden..." : "Anmelden"}
              </button>
            </div>
          </form>

          <div className="auth-links">
            <span>
              Noch kein Konto?{" "}
              <Link to={`/registrieren${next !== "/konto" ? `?next=${encodeURIComponent(next)}` : ""}`}>
                Jetzt registrieren →
              </Link>
            </span>
            <Link to="/auth/passwort-vergessen">Passwort vergessen?</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default LoginPage;
